import React from 'react'
import type { MetricCardGridProps } from './MetricCard.types'
import './MetricCard.css'

const MetricCardGrid: React.FC<MetricCardGridProps> = ({
  children,
  columns = 3,
  className = '',
}) => {
  const classNames = [
    'ds-metric-card-grid',
    `ds-metric-card-grid--cols-${columns}`,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return <div className={classNames}>{children}</div>
}

export default MetricCardGrid
